import { render, staticRenderFns } from "./ApplicationReviewDetail.vue?vue&type=template&id=46637997&scoped=true&"
import script from "./ApplicationReviewDetail.vue?vue&type=script&lang=js&"
export * from "./ApplicationReviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationReviewDetail.vue?vue&type=style&index=0&id=46637997&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46637997",
  null
  
)

export default component.exports